'use client';
import Section from '@repo/ui/src/components/Section';
import { ToutContent } from '@repo/ui/src/components/ToutContent/_toutContent';
import { HeaderVariationProps } from '@repo/ui/src/types';

interface Props {
  heading: string;
  headerVariation: HeaderVariationProps;
  headingStyle: any;
  lilHeading: string;
  description: string;
  buttons: Array<any>;
}

export const SplitToutContent = ({
  heading,
  headerVariation,
  headingStyle,
  lilHeading,
  description,
  buttons,
}: Props) => (
  <Section white gutterX gutterY basePadding className="tw-pb-0">
    <div className="tw-grid tw-grid-cols-12 tw-gap-x-4">
      <div className="tw-col-span-12 md:tw-col-span-5">
        <ToutContent
          heading={heading}
          headerVariation={headerVariation}
          headingStyleVariant={headingStyle || 'h2'}
          lilHeading={lilHeading}
          forceDivider
          align="left"
        />
      </div>
      <div className="tw-hidden md:tw-block md:tw-col-span-1" />
      <div className="tw-col-span-12 md:tw-col-span-6">
        <ToutContent description={description} buttons={buttons} align="left" />
      </div>
    </div>
  </Section>
);

export default SplitToutContent;